import React from 'react';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  TableBody,
  Paper,
} from '@mui/material';
import moment from 'moment';
import { IUserExperience } from '../../../../store/UserSlice';

interface ExperienceTableProps {
  experiences: IUserExperience[];
}

const ExperienceTable: React.FC<ExperienceTableProps> = ({ experiences }) => {
  return (
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{ width: '100%', backgroundColor: 'transparent' }}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography variant="subtitle1" fontWeight="bold">
                Job Title
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="subtitle1" fontWeight="bold">
                Work Place
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="subtitle1" fontWeight="bold">
                From
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="subtitle1" fontWeight="bold">
                To
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {experiences.map((row, index) => (
            <TableRow key={index}>
              <TableCell>
                <Typography variant="body2" color="text.secondary">
                  {row.jobTitle}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2" color="text.secondary">
                  {row.workPlace}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2" color="text.secondary">
                  {moment(row.startDate).year()}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2" color="text.secondary">
                  {moment(row.endDate).year()}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ExperienceTable;
